import React from 'react';

export const Layouts = { 
	default: React.lazy(() => import('./Layout1/Default')),
	profile: React.lazy(() => import('./Layout1/Profile')),
	dashboard: React.lazy(() => import('./Layout1/Dashboard')), 
};
